<template>
  <div class="status-card" :style="{ background: bgColor }">
    <h1 class="status-text" :style="{ color: textColor }">{{ text | upperCase}}</h1>
  </div>
</template>

<script>
export default {
  name:'qb-status-card',
  props: {
    text: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '#000',
    },
    bgColor: {
      type: String,
      default: '#fff',
    },
  },
}
</script>

<style>
.status-card {
  width: 100%;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.status-text {
  font-size: 1rem;
  font-weight: bold;
}
</style>